import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import React from "react";
import PropTypes from "prop-types";

const Loader = ({ size = 24 }) => (
  <Stack direction="column">
    <Grid container justifyContent="center">
      <CircularProgress size={size || 24} color="primaryC" />
    </Grid>
  </Stack>
);

// typechecking props for Loader
Loader.propTypes = {
  size: PropTypes.number,
};

export default Loader;
